import Axios from "axios";

const axios = Axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  withCredentials: false,
});

// axios.interceptors.request.use((c) => {
//   const config = { ...c };
//   const json = localStorage.getItem('session');

//   if (json) {
//     try {
//       const { accessToken } = JSON.parse(json);

//       if (accessToken) {
//         config.headers.Authorization = `Bearer ${accessToken}`;
//       }
//     } catch (e) {
//       /* */
//     }
//   }

//   return config;
// });

export default axios;
